import React from 'react'
import Wadhead from './Wadhead/Wadhead'
import Wwo from './Wwo/Wwo'
import Wgbs from './Wgbs/Wgbs'
import Wcdw from './Wcdw/Wcdw'

function WebApplicationDevelopment() {
  return (
    <>
      <Wadhead/>
      <Wwo />
      <Wcdw />
      <Wgbs />
    </>
  )
}

export default WebApplicationDevelopment
